import {
    GET_WORD,
    UPDATE_WORD
} from '../actions/types';

const INITIAL_STATE = {
    word: 'initial word'
};

export default (state = INITIAL_STATE, action) => {

    switch (action.type) {
        case GET_WORD:
            return { ...state, word: action.payload };
        case UPDATE_WORD:
            return { ...state, word: action.payload };
        default:
            return state;
    }

}